import Team from 'models/TeamModel';
import TeamMember from 'models/TeamMemberModel';

import { myCompanyTeams } from './types';

import { normalizeModelList, normalizeIds } from '../../utils/Normalizer';

const myCompanyTeamsReducerObject = {
  [myCompanyTeams.request]: (state) => state.setIn(['myCompanyTeams', 'network', 'loading'], true),
  [myCompanyTeams.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['myCompanyTeams', 'network', 'loading'], false)
        .setIn(['myCompanyTeams', 'network', 'error'], false)
        .setIn(['myCompanyTeams', 'data'], normalizeIds(action.response))
        .mergeIn(
          ['teamsById'],
          normalizeModelList(action.response, (...args) => Team.deserialize(...args).normalize()),
        )
        .mergeIn(
          ['membersById'],
          normalizeModelList(
            action.response.reduce((acc, team) => (team.users ? [...acc, ...team.users] : acc), []),
            TeamMember.deserialize,
          ),
        ),
    ),
  [myCompanyTeams.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['myCompanyTeams', 'network', 'loading'], false)
        .setIn(['myCompanyTeams', 'network', 'error'], action.error),
    ),
};

export default myCompanyTeamsReducerObject;
